export default __webpack_public_path__ + "13a9e0f3ac22928e91dd6503041d3834.png";